import { useState } from "react";
import PromocionListado from "./PromocionListado";
import PromocionPrecioNuevoModal from "./PromocionPrecioNuevoModal";
import usePermissions from "../../../hook/usePermissions";
import Boton from "../../UI/Boton";
import { IconoMas } from "../../UI/Iconos";

/**
 * SEGUROS-PLANES FASE 2 · `seguroId` OPCIONAL.
 *
 * Sin el prop, la pestana Promociones de /configuracion no cambia nada.
 * Con el, el listado se filtra por esa aseguradora EN EL SERVIDOR (P1).
 *
 * El encargo dice explicitamente "no la redisenes ahora; solo filtrala", asi
 * que el modal de alta se queda tal cual -- con su propio selector de seguro.
 * Es la unica pregunta de contexto que sobrevive en el flujo nuevo, y esta
 * anotada como pendiente para cuando toque rehacer Promociones.
 */
export default function Promocion({ seguroId = null }) {
    // RBAC-CUTOVER-07: Crear depende de promociones.create (backend ya lo
    // exige en promocion.routes.ts); Editar/Eliminar se gatean dentro de
    // PromocionListado.js.
    const { hasPermission } = usePermissions();
    const [reloadPromociones, setReloadPromociones] = useState(false);
    const [showPromocionNuevo, setShowPromocionNuevo] = useState(false);

    const handlePromocionNuevo = () => {
        setShowPromocionNuevo(!showPromocionNuevo);
        if (showPromocionNuevo) {
            setReloadPromociones(prev => !prev);
        }
    }

    return (
        <section>
            {hasPermission("promociones.create") && (
                <div className="d-flex justify-content-end mb-3">
                    <Boton variante="primario" icono={IconoMas} onClick={handlePromocionNuevo} data-testid="promocion-crear">
                        Crear Promoci&oacute;n
                    </Boton>
                </div>
            )}

            <PromocionListado data= {{ reloadPromociones: reloadPromociones, seguroId }}/>

            <PromocionPrecioNuevoModal
                data={{
                    show: showPromocionNuevo,
                    handleClose: handlePromocionNuevo,
                }}
            />
        </section>
    )
}